<template>
  <div class="sliders">
    <offer-proposal
      v-if="isOfferProposal"
      :is-opened="isOfferProposal"
      :payload="payload[currentOpenedComponent]"
      @close="close"
    />
    <refuse-proposal
      v-if="isRefuseProposal"
      :is-opened="isRefuseProposal"
      :payload="payload[currentOpenedComponent]"
      @close="close"
    />
  </div>
</template>

<script>
import eventBus from '@tools/event-bus';
import { OFFER_EVENT, SLIDERS } from '@organisms/offer/constants';
import OfferProposal from './Sliders/OfferProposal.vue';
import RefuseProposal from './Sliders/RefuseProposal.vue';

export default {
  components: {
    RefuseProposal,
    OfferProposal,
  },
  data() {
    return {
      currentOpenedComponent: '',
      payload: {},
    };
  },
  computed: {
    isOfferProposal() {
      return this.currentOpenedComponent === SLIDERS.OFFER_PROPOSAL;
    },
    isRefuseProposal() {
      return this.currentOpenedComponent === SLIDERS.REFUSE_PROPOSAL;
    },
  },
  mounted() {
    this.setupListeners();
  },
  beforeUnmount() {
    this.removeListeners();
  },
  methods: {
    close() {
      const closedComponent = this.currentOpenedComponent;
      this.currentOpenedComponent = '';
      delete this.payload[closedComponent];
    },
    setupListeners() {
      this.sliderShowListener = (event) => {
        const { sliderType, sliderPayload } = event.detail;
        this.currentOpenedComponent = sliderType;
        this.payload[this.currentOpenedComponent] = sliderPayload;
      };

      eventBus.addEventListener(OFFER_EVENT.SLIDER_SHOW, this.sliderShowListener);
    },
    removeListeners() {
      eventBus.removeEventListener(OFFER_EVENT.SLIDER_SHOW, this.sliderShowListener);
    },
  },
};
</script>
